/* eslint-disable react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';
import Linkify from 'omz-react-linkify';

import Bubble from '../../../Atoms/Bubble';
import { useBan } from '../../../../context/bannedContent';

const MessageText = ({ messageInfo, children }) => {
	const { cleanBadWords } = useBan();

	const isClientMessage = messageInfo.origin === 'CLIENT';
	const message = isClientMessage ? cleanBadWords('receivedText', messageInfo.content) : messageInfo.content;

	const plainString = message?.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '')
		.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
		.replace(/<div id="omzSignature[\s\S]*$/i, '')
		.replace(/<br\s*\/?>/gi, '\n')
		.replace(/(\n){3,}/g, '\n\n')
		.replace(/<(?!img\b)[^>]+>/gi, '')
		.replace(/&nbsp;/g, ' ')
		.replace(/&amp;/g, '&')
		.replace(/&lt;/g, '<')
		.replace(/&gt;/g, '>')
		.replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec))
		.replace(/[ \t]+/g, ' ')
		.trim();

	return (
		<Bubble messageInfo={messageInfo}>
			{children}
			{(messageInfo?.media === 'EMAIL' || messageInfo?.interactionType === 'EMAIL') ? <div dangerouslySetInnerHTML={{ __html: plainString }} />
				: (
					<Linkify properties={{ target: '_blank' }}>
						{message}
					</Linkify>
				)}
		</Bubble>
	);
};

MessageText.propTypes = {
	messageInfo: PropTypes.shape({
		content: PropTypes.string,
		origin: PropTypes.string,
		referenceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		interactionType: PropTypes.string,
		media: PropTypes.string
	}).isRequired
};

export default MessageText;
